const fetchStudentsListBySchoolId = async (url, abortController, token) => {
  abortController.current = new AbortController();

  const options = {
    signal: abortController.current.signal,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorResponse = await response.json();
      const error = new Error(
        `Failed to fetch student list: ${JSON.stringify(errorResponse)} ${response.status}`
      );
      throw error;
    }
    return await response.json();
  } catch (error) {
    throw new Error("Error while fetching student list", { cause: error });
  }
};

export default fetchStudentsListBySchoolId;
